<script>
  import { onMount } from 'svelte';
  import Button from '@ui/pico/button.svelte';
  import { pages } from '../../../config';
  import { goto } from '../../../util';
  import { getForms, getSites } from '../../../services';
  import FeIcon from '../../components/fe-icon.svelte';

  export let selectedForm = null;
  export let selectedSite = null;
  let action = null;
  let activeData = null;

  $: sites = [];
  $: forms = [];
  $: currentSite = sites.find((s) => s._id === selectedSite);
  $: siteForms = forms.filter((f) => f.sid === selectedSite);
  $: currentForm = forms.find((f) => f._id === selectedForm);
  $: slc = currentSite?._id;
  $: flc = currentForm?.formLinkCode;
  $: siteName = currentSite?.domain || null;

  onMount(async () => {
    sites = await getSites();
    forms = await getForms();
  });
  function goToAddSite() {
    window.location = pages.sites.add.url;
  }
  function deleteSite() {
    action = 'showDeleteSiteConfirm';
    activeData = {
      site: siteName,
      numForms: siteForms?.length,
      form: [{ type: 'hidden', name: 'id', value: selectedSite }],
    };
  }
  function goToSiteOverview() {
    const sid = currentSite?._id;
    goto(pages.sites.overview.url, sid);
  }
  function goToBuilder() {
    slc = slc || currentForm?.sid;
    goto(pages.components.url, slc, flc);
  }
  function editSite() {
    action = 'showEditSiteForm';
    activeData = {
      form: [
        { type: 'hidden', name: 'id', value: selectedSite },
        {
          type: 'text',
          placeholder: 'Domain Name',
          name: 'domain',
          value: siteName,
        },
      ],
    };
  }
</script>

<div class="grid">
  <article style="margin:2em 1em;">
    <label class="title-label" for="sites">
      <i class="fa fa-plus-circle" on:click={goToAddSite} on:keyup={null} />
      {#if sites?.length === 0}
        <span on:click={goToAddSite} on:keyup={null}>Add a Site</span>
      {:else}
        <span>Sites</span>
      {/if}
    </label>
    <select name="sites" bind:value={selectedSite}>
      <option value={null}>Select Site</option>
      {#each sites as site}
        <option value={site?._id}>
          {site?.domain} ({site?.description || 'no description'})
        </option>
      {/each}
    </select>
    <div class="grid">
      <Button disabled={!selectedSite} class="contrast" on:click={goToBuilder}>
        <FeIcon name="code" />
      </Button>
      <Button
        disabled={!selectedSite}
        class="contrast"
        on:click={goToSiteOverview}
      >
        <FeIcon name="eye" />
      </Button>
      <Button disabled={!selectedSite} class="contrast" on:click={editSite}>
        <FeIcon name="edit" />
      </Button>
      <Button disabled={!selectedSite} class="delete-btn" on:click={deleteSite}>
        <FeIcon name="x" />
      </Button>
    </div>
  </article>
</div>

<style>
  .grid {
    border: solid thin red;
  }
</style>

<!-- <style>
  :root {
    --icon-size: 2rem;
  }
  label {
    font-size: 1.4em;
    padding: 1em 0;
  }
  :global([disabled]) {
    opacity: 0.15;
  }
  :global(.delete-btn) {
    background: maroon;
  }
  :global(.fe-icon > svg) {
    stroke-width: var(--stroke-width);
    width: var(--icon-size);
    height: var(--icon-size);
  }
</style> -->
